/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadBatchFinalizeResponse
 */
export interface UploadBatchFinalizeResponse {
    /**
     * 
     */
    batchId: string;
    /**
     * 
     */
    expectedCount: number;
}

/**
 * Check if a given object implements the UploadBatchFinalizeResponse interface.
 */
export function instanceOfUploadBatchFinalizeResponse(value: object): value is UploadBatchFinalizeResponse {
    if ((!('batchId' in (value as Record<string, any>)) && !('batch_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['batchId'] === undefined && (value as Record<string, any>)['batch_id'] === undefined)) return false;
    if ((!('expectedCount' in (value as Record<string, any>)) && !('expected_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['expectedCount'] === undefined && (value as Record<string, any>)['expected_count'] === undefined)) return false;
    return true;
}

export function UploadBatchFinalizeResponseFromJSON(json: any): UploadBatchFinalizeResponse {
    return UploadBatchFinalizeResponseFromJSONTyped(json, false);
}

export function UploadBatchFinalizeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadBatchFinalizeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'batchId': json['batch_id'],
        'expectedCount': json['expected_count'],
    };
}

export function UploadBatchFinalizeResponseToJSON(json: any): UploadBatchFinalizeResponse {
    return UploadBatchFinalizeResponseToJSONTyped(json, false);
}

export function UploadBatchFinalizeResponseToJSONTyped(value?: UploadBatchFinalizeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'batch_id': value['batchId'],
        'expected_count': value['expectedCount'],
    };
}

